
import { Component, Vue } from 'vue-property-decorator'
import Tracklist from './Tracklist.vue'
import MusicServices from './MusicServices.vue'
import FocusArtists from './FocusArtists.vue'

@Component({ components: { Tracklist, MusicServices, FocusArtists } })
export default class CampaignMusic extends Vue {
}
